/* eslint-disable */
import { VassNavigationItem } from '@vass/components/navigation';

export const defaultNavigation: VassNavigationItem[] = [
  {
    id: 'home',
    title: 'Home',
    type: 'basic',
    link: '/',
  },
  {
    id: 'examples',
    title: 'VASS SDK',
    type: 'basic',
    link: '/vass-sdk',
  },
  {
    id: 'back-office',
    title: 'LOGIN',
    type: 'basic',
    link: '/back-office',
  },
  {
    id: 'home-office',
    title: 'HOME OFFICE EXPERIENCE',
    type: 'basic',
    link: '/home-office',
  },
  {
    id: 'attendees-list',
    title: 'ATTENDEES LIST',
    type: 'basic',
    link: '/home-office/attendees-list',
  },
  {
    id: 'various-experiences',
    title: 'VARIOUS EXPERIENCES',
    type: 'basic',
    link: '/home-office/various-experiences',
  },
  {
    id: 'experience-detail',
    title: 'EXPERIENCE DETAIL',
    type: 'basic',
    link: '/home-office/experience-detail',
  },
  {
    id: 'quiz',
    title: 'QUIZ GAME',
    type: 'basic',
    link: '/quiz',
  },
];
